import React, { useState, useRef, useEffect } from "react";

const WhatYoureMovingSection = ({ items , handleUpdateBookingObject }) => {
  const [movingOpen, setMovingOpen] = useState(false);
  const movingRef = useRef(null);
  const [movingMaxHeight, setMovingMaxHeight] = useState("0px");

  // Keep the measured height for the moving section up-to-date
  useEffect(() => {
    if (!movingRef.current) return;
    if (movingOpen) setMovingMaxHeight(`${movingRef.current.scrollHeight}px`);
    else setMovingMaxHeight("0px");
  }, [movingOpen]);

  // Update moving section height on resize
  useEffect(() => {
    const onResize = () => {
      if (movingOpen && movingRef.current)
        setMovingMaxHeight(`${movingRef.current.scrollHeight}px`);
    };
    window.addEventListener("resize", onResize);
    return () => window.removeEventListener("resize", onResize);
  }, [movingOpen]);

  return (
    <div className="mb-4">
      <div className="flex gap-x-2 items-center mb-[7px]">
        <img
          src="/images/NewUiIcons/whatsmove.svg"
          alt="What you're moving icon"
        />
        <p className="text-[#7876A1] text-[16px] font-bold">
          What you're moving
        </p>
         <img
              src="/images/NewUiIcons/Edit.svg"
              alt="edit"
              className="w-[23px] h-[23px] cursor-pointer"
              onClick={()=>handleUpdateBookingObject("tripStatus", "visionItems", "EditBookingFromSummaryvisionItems")}
            />
      </div>

      {/* Toggle button (arrow + text) - matches other sections */}
      <div className="mb-[8px] flex items-center gap-2 pl-[26px]">
        <button
          onClick={() => setMovingOpen((s) => !s)}
          aria-expanded={movingOpen}
          className="flex items-center focus:outline-none"
        >
          <img
            src="/Vision Agent Icons/Back Arrow/ChevronLightPurple.svg"
            alt={movingOpen ? "collapse details" : "expand details"}
            className={`w-3 h-3 transform transition-transform duration-300 ${movingOpen ? "rotate-180" : "rotate-0"
              }`}
          />
        </button>

        <button
          onClick={() => setMovingOpen((s) => !s)}
          aria-expanded={movingOpen}
          className="text-[#7876A1] text-[12px] font-medium focus:outline-none"
        >
          {movingOpen ? "Hide details" : "Show details"}
        </button>
      </div>

      {/* Collapsible list with smooth height transition */}
      <div
        ref={movingRef}
        className={`${movingOpen ? "h-auto" : "h-0"
          } overflow-hidden transition-all duration-300`}
        style={{ maxHeight: movingMaxHeight }}
      >
        <ul className="text-[#211F59] text-[14px] font-[500] list-[square] pl-11">
          {Array.isArray(items) && items.length > 0 ? (
            items.map((item, idx) => {
              const name = item?.name;
              const count =
                typeof item?.quantity !== "undefined"
                  ? item.quantity
                  : null;
              if (!name) return null;
              return (
                <li key={idx}>{count !== null ? `${count}x ${name}` : name}</li>
              );
            })
          ) : (
            <>
              <li>No items listed.</li>
            </>
          )}
        </ul>
      </div>
      <div
        style={{
          height: "0.5px",
          backgroundColor: "#7876A1",
          marginTop: "18.63px",
          marginBottom: "23.29px",
        }}
      />
    </div>
  );
};

export default WhatYoureMovingSection;
